export enum LiveChatStatus {
  Available = 'AVAILABLE',
  Unavailable = 'UNAVAILABLE',
  Ineligible = 'INELIGIBLE',
}
